import {
    httpStoreProjectMedicalDevices,
    HttpStoreProjectMedicalDevicesOptions
} from '@/features/projects/http/projects.http'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'

export const useStoreProjectMedicalDevices = ({
    urlParams,
    options
}: {
    urlParams: HttpStoreProjectMedicalDevicesOptions['urlParams']
    options?: UseMutationOptions<unknown, unknown, HttpStoreProjectMedicalDevicesOptions['payload']>
}) => useMutation({mutationFn: payload => httpStoreProjectMedicalDevices({urlParams, payload}), ...options})
